module.exports = __webpack_public_path__ + "static/media/incident_category-maritime.774e594b.svg";